module.exports = __webpack_public_path__ + "img/7.c97b434e.jpeg";